<template>
  <InteractionStep :has-next="false">
    <template v-slot:content>
      <div class="step-text">
<!--        <img src="../../../assets/img/svg/employment-type/4.svg"-->
<!--             alt="Обратите внимание"-->
<!--             class="step-text__img">-->
        <h3 class="step-text__title">{{ $tInteraction('Interaction complete') }}</h3>
        <div class="step-text__text text">
          <p>{{$tInteraction('Interaction complete text')}}</p>
        </div>

      </div>
    </template>
  </InteractionStep>
</template>

<script>
  import InteractionStep from '../InteractionStep'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'InteractionStepPassport2',
    mixins: [interactionStepMixin],
    data() {
      return {
        pendingSave: false,
        error: null,
      }
    },
    components: {
      InteractionStep
    }
  }
</script>

<style>

</style>
